<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Account Pay Create Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Detail" />
    </a-steps>
    <div class="steps-content flex-1">
      <keep-alive>
        <component
          class="flex-1"
          :is="steps[current].content"
          :ref="stepRef"
          v-bind="stepProps"
        ></component>
      </keep-alive>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          :loading="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >Save</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Informasi from "./steps/Informasi.vue";
import Detail from "./steps/Detail.vue";
import moment from "moment";
import _ from "lodash";

export default {
  name: "CreateAP",
  props: ["id", "type"],
  mixins: [CurrencyFormat],
  components: {
    Informasi,
    Detail,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Detail",
          content: "Detail",
        },
      ],
      mode: "Create",
      collectData: {
        informasi: [],
        listData: {},
      },
      templistData: {},
      postData: new FormData(),
      postJson: {},
      editData: {},
      btnLoading: false,
      files: [],
      po_wo_dtl: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate"]),
    // initialListItem() {
    //   console.log("initialListItem")
    //   let data = [];
    //   let hargaTotal = 0;
    //   // if (this.mode === "Edit") {
    //   //   this.listPembelian.forEach(item => {
    //   //     hargaTotal = item.values.jumlah * item.values.harga;
    //   //     const values = item.values;
    //   //     data = [...data, { hargaTotal: hargaTotal, values }];
    //   //   });
    //   // } else {
    //     if(this.collectData.listData.length>0)
    //     this.collectData.listData.forEach(item => {
    //       hargaTotal = item.jumlah * item.harga;
    //       data = [
    //         ...data,
    //         {
    //           hargaTotal: hargaTotal,
    //           values: item
    //         }
    //       ];
    //     });
    //   // }
    //   return data;
    // },
    stepProps: function() {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            id: this.id,
            type: this.type,
            data: this.collectData.informasi,
            mode: this.mode,
            listData: this.collectData.listData,
          };
        } else if (this.steps[this.current].content === "Detail") {
          return {
            listData: this.templistData,
            // keuangan: this.keuangan,
            informasi: this.collectData.informasi,
            mata_uang: this.collectData.informasi.mata_uang,
            // shipping : this.collectData.informasi.shipping,
            // check_shipping : this.collectData.informasi.check_shipping,
            // tax: this.collectData.informasi.tax,
            // mode: "Edit",
            // mata_uang: this.collectData.selectedPP[0] ? this.collectData.selectedPP[0].currency : null,
            // id_pp: this.collectData.informasi.id_pp,
            po_wo_dtl: this.po_wo_dtl,
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            id: this.id,
            type: this.type,
            data: this.collectData.informasi,
            mode: this.mode,
            listData: this.collectData.listData,
          };
        } else if (this.steps[this.current].content === "Detail") {
          return {
            listData: this.collectData.listData,
            informasi: this.collectData.informasi,
            mata_uang: this.collectData.informasi.mata_uang,
            po_wo_dtl: this.po_wo_dtl,
          };
        }
      }
      return true;
    },
    stepRef: function() {
      let val = "";
      if (this.steps[this.current].content === "Informasi") {
        val = "refInformasi";
      } else if (this.steps[this.current].content === "Detail") {
        val = "refDetail";
      }
      return val;
    },
  },
  created() {
    if (this.id) {
      //this.mode = "Edit";
      //this.fetchDetail();
    }
  },
  methods: {
    moment,
    next() {
      //console.log(this.steps[this.current].content)
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetail.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refDetail.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        // if (this.mode === "Create") {
        //   this.collectData.informasi = JSON.parse(
        //     JSON.stringify(value.informasi)
        //   );
        // }

        this.collectData.informasi = JSON.parse(
          JSON.stringify(value.informasi)
        );
        //console.log("child",value)
        //this.collectData.listData = JSON.parse(JSON.stringify(value.listData));
        this.po_wo_dtl = value.po_wo_dtl;
        this.files = value.files;

        this.current++;
      } else if (this.steps[this.current].content === "Detail") {
        this.collectData.listData = value.listData;
        this.collectData.emptyValidator = value.emptyValidator;
        this.collectData.total = value.total;

        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    getUpdateList(item) {
      //this.templistData = [...this.templistData, JSON.parse(JSON.stringify(item.value))];
      let val = [];
      if (this.collectData.listData.length > 0) {
        if (item.type == "update") {
          val = this.collectData.listData;
        }
      }
      //val.push(this.collectData.listData)
      if (item.value && item.type == "update") {
        val.push(item.value);
      } else if (item.value && item.type == "delete") {
        val = item.value;
      }
      //console.log("val",val)
      this.collectData.listData = val;
      this.templistData = val;
      //console.log("getUpdateList",this.collectData.listData)
    },
    setSubmitForm() {
      //console.log("simpan")

      this.postData = new FormData();
      if (this.mode === "Edit") {
        this.postData.append("id_account_pay", this.id);
      }
      this.postData.append("tlc", this.getAuth.username);
      this.postData.append(
        "date_of_ap",
        moment(this.collectData.informasi.date_of_ap).format(
          this.getStandartFormatDate
        )
      );
      // this.postData.append(
      //   "jenis_transaksi",
      //   this.collectData.informasi.jenis_transaksi
      // );
      this.postData.append(
        "id_invoice_ap_ad",
        this.collectData.informasi.no_po_wo_addendum
      );
      this.postData.append(
        "description",
        this.collectData.informasi.description
      );

      let minusTaxBearerInfoglobal = 0;
      let pphexist = _.filter(this.collectData.listData, item=> item.type_tax && item.type_tax.includes("pph") && item.bearer_tax=='0');
      if(pphexist.length>0){
        minusTaxBearerInfoglobal = _.sumBy(pphexist, function (val) {
          return Number(val.valueTotal)
        });
      }

      this.postData.append("value", this.collectData.total-minusTaxBearerInfoglobal);
      this.postData.append("note", this.collectData.informasi.note);
      this.postData.append("nama_document", this.files[0]);

      this.collectData.listData.forEach((data, index) => {
        this.postData.append(
          `kategori[${index}]`,
          data.used_for ? data.used_for : ""
        );
        this.postData.append(
          `type_tax[${index}]`,
          data.type_tax ? data.type_tax : ""
        );
        this.postData.append(
          `id_invoice_dtl[${index}]`,
          !(
            data.powopdtl &&
            data.used_for == "2" &&
            data.type_tax &&
            data.type_tax.includes("pph")
          )
            ? data.powopdtl
            : ""
        );
        this.postData.append(
          `id_po_wo_dtl[${index}]`,
          data.powopdtl &&
            data.used_for == "2" &&
            data.type_tax &&
            data.type_tax.includes("pph")
            ? data.powopdtl
            : ""
        );
        this.postData.append(
          `item_dtl[${index}]`,
          data.nama_item ? data.nama_item : ""
        );
        this.postData.append(`prosentase[${index}]`, null);
        this.postData.append(`harga[${index}]`, data.value ? data.value : "");
        this.postData.append(`catatan[${index}]`, data.note ? data.note : "");
        this.postData.append(
          `bearer_tax[${index}]`,
          data.bearer_tax ? data.bearer_tax : ""
        );
        this.postData.append(
          `jumlah[${index}]`,
          data.quantity ? data.quantity : ""
        );
        this.postData.append(
          `file_document_tax[${index}]`,
          data.attachment ? data.attachment : ""
        );
      });
    },
    submit() {
      if (this.collectData.emptyValidator == 0) {
        this.displayMessage("empty-aplist");
        return;
      }

      if (this.collectData.listData.length === undefined) {
        this.displayMessage("empty-aplist");
        return;
      } else {
        let lst = this.collectData.listData.filter((item, index) => {
          if (item.value <= 0) return item;
        });
        if (lst.length > 0) {
          this.displayMessage("empty-aplist");
          return;
        }
      }

      this.setSubmitForm();
      this.btnLoading = true;
      let method = "";
      let data = "";
      let url = "";
      if (this.mode === "Create") {
        method = "post";
        data = this.postData;
        url = this.$serviceUrl + "account_pay/submit";
      } else {
        method = "post";
        data = this.postData;
        url = this.$serviceUrl + "account_pay/edit";
      }

      axios({
        method: method,
        url: url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }
          this.btnLoading = false;
          this.current = 0;
          this.$router.push({ name: "account-pay-index" });
        })
        .catch((err) => {
          let response = Object.assign({}, err.response);
          if (response.data.message.includes("Saldo PP tidak cukup")) {
            let sisa = this.formatCurrency(
              this.collectData.selectedPP[0].currency,
              response.data.message.replace("Saldo PP tidak cukup!", "")
            );
            this.displayMessageValue("pp-notenough", sisa);
          } else if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            //console.log(responses);
            this.displayMessageValue("error", responses);
          }
          this.btnLoading = false;
        });
    },
    // fetchDetail() {
    //   axios({
    //     method: "get",
    //     url: this.$serviceUrl + "po/po_Detil_v2",
    //     params: {
    //       id_manifest: this.id,
    //       tlc: this.getAuth.username
    //     },
    //     auth: {
    //       username: this.getAuth.username,
    //       password: this.getAuth.password
    //     },
    //     headers: {
    //       "X-API-KEY": this.getAuth.apikey
    //     }
    //   })
    //     .then(response => {
    //       if (parseInt(response.data.informasi.tax) >= 0) {
    //         response.data.informasi.check_tax = true;
    //       }

    //       if (parseInt(response.data.informasi.shipping) >= 0) {
    //           response.data.informasi.check_shipping = true;
    //       }

    //       this.collectData = {
    //         informasi: response.data.informasi
    //       };

    //       this.keuangan = JSON.parse(JSON.stringify(response.data.keuangan[0]));

    //       // response.data.detail_po.forEach(item => {
    //       //   this.listPembelian = [...this.listPembelian, { values: item }];
    //       // });
    //     })
    //     .catch(err => {
    //       let responses = Object.assign({}, err.response.data);
    //       this.displayMessageValue("error",responses);
    //     });
    // }
    getUpdatePoWoList(value) {
      this.po_wo_dtl = value.value;
    },
  },
  mounted() {
    Event.$on("apData", this.valueFromChild);
    //Event.$on("listPembelian", this.getListPembelian);
    Event.$on("updateList", this.getUpdateList);
    Event.$on("updatepowodtl", this.getUpdatePoWoList);
    Event.$on("confirmMessageReturn", this.submit);

    if (this.$route.name == "account-pay-edit") this.mode = "Edit";
  },
  beforeDestroy() {
    Event.$off("apData", this.valueFromChild);
    //Event.$off("listPembelian", this.getListPembelian);
    Event.$off("updateList", this.getUpdateList);
    Event.$off("updatepowodtl", this.getUpdatePoWoList);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style></style>
